import { render, staticRenderFns } from "./OrgCommonPrescriptions.vue?vue&type=template&id=3eec8e8d&scoped=true"
import script from "./OrgCommonPrescriptions.vue?vue&type=script&lang=js"
export * from "./OrgCommonPrescriptions.vue?vue&type=script&lang=js"
import style0 from "./OrgCommonPrescriptions.vue?vue&type=style&index=0&id=3eec8e8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eec8e8d",
  null
  
)

export default component.exports